import { render, staticRenderFns } from "./academy_academy.vue?vue&type=template&id=0a28cb12&"
import script from "./academy_academy.vue?vue&type=script&lang=js&"
export * from "./academy_academy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderDefault: require('/home/smiley/3df/components/Header/HeaderDefault/HeaderDefault.vue').default,BannerPromoCourse: require('/home/smiley/3df/components/Banner/BannerPromoCourse/BannerPromoCourse.vue').default,OverlaySlider: require('/home/smiley/3df/components/OverlaySlider/OverlaySlider.vue').default,AcademySectionRegister: require('/home/smiley/3df/components/AcademySectionRegister/AcademySectionRegister.vue').default})
